import React, { useEffect, useState } from "react";
import { RootState } from "../../../../redux/rootReducers";
import { resetSession } from "../../../../redux/auth";
import { connect } from "react-redux";
import {
  resetMasterError,
  resetMasterMessage,
  resetMasterStatusCode,
  resetMasterSuccess,
} from "../../../../redux/masterData";
import {
  addTurnOverHSNCheckAction,
  getHsnCheckAction,
  resetClientMappedHSNData,
  resetClientSettingsError,
  resetClientSettingsSuccess,
  resetMessage,
  updateTurnOverHSNCheckAction,
} from "../../../../redux/clientSettings";

import { ErrorSuccessModal, Loader, ToggleSwitch } from "../../../commons";
import { useParams } from "react-router-dom";

import toast, { Toaster } from "react-hot-toast";
import { AddTurnOverHSNCheckPayloadType, GetHSNCheckPayloadType, UpdateTurnOverHSNCheckPayloadType } from "../../../../commonTypes/clientSettingsTypes";

type AppProps = {
  history: any;
  token: string | null;
  masterFetching: boolean;
  masterStatusCode: null | number;
  masterError: null | string;
  masterSuccess: null | number;
  masterMessage: string | null;
  menuName: string;
  success: null | number;
  fetching: boolean;
  error: null | string;
  statusCode: null | number;
  message: string | null;
  dispatchResetSession: () => void;
  dispatchResetMasterSuccess: () => void;
  dispatchResetClientSettingMessage: () => void;
  dispatchResetMasterError: () => void;
  dispatchResetMasterMessage: () => void;
  dispatchResetMasterStatusCode: () => void;
  dispatchResetClientSettingsSuccess: () => void;
  dispatchResetClientSettingsError: () => void;

  dispatchGetHsnCheckAction: (data: GetHSNCheckPayloadType) => void;
  dispatchAddTurnOverHSNCheckAction: (data: AddTurnOverHSNCheckPayloadType) => void;

  dispatchUpdateTurnOverHSNCheckAction: (data: UpdateTurnOverHSNCheckPayloadType) => void;
  clientMappedHSNData: any;
  dispatchResetClientMappedHSNData: () => void;
};

const HsnCheck = ({
  history,
  token,
  masterFetching,
  masterStatusCode,
  masterError,
  masterSuccess,
  masterMessage,
  success,
  fetching,
  error,
  statusCode,
  message,
  menuName,

  dispatchResetSession,
  dispatchResetMasterSuccess,
  dispatchResetMasterError,
  dispatchResetMasterMessage,
  dispatchResetMasterStatusCode,
  dispatchResetClientSettingsSuccess,
  dispatchResetClientSettingMessage,
  dispatchResetClientSettingsError,
  dispatchGetHsnCheckAction,
  dispatchAddTurnOverHSNCheckAction,
  dispatchUpdateTurnOverHSNCheckAction,
  dispatchResetClientMappedHSNData,
  clientMappedHSNData,
}: AppProps) => {
  const company_name = history?.location?.state?.company_name;
  const client_code = history?.location?.state?.client_code;
  const [isHSNCheck, setIsHSNCheck] = useState(false);
  const [clientTurnover, setClientTurnOver] = useState("");
  const { id }: any = useParams();
  const [editId, setEditId] = useState<string>();

  

  useEffect(() => {
    dispatchResetMasterSuccess();
    dispatchResetMasterError();
    dispatchResetClientSettingMessage();
    dispatchResetMasterMessage();
    dispatchResetMasterStatusCode();
    dispatchResetClientSettingsSuccess();
    dispatchResetClientSettingsError();
    dispatchResetClientMappedHSNData();
    setClientTurnOver("");
    toast.dismiss();
    if (token) {
      let mappedFinalData = {
        token,
        clientCode: id,
      };
      dispatchGetHsnCheckAction(mappedFinalData);
    }
    return () => {
      toast.dismiss();
    };
  }, []);
  

  useEffect(() => {
    
    if (clientMappedHSNData && Object.keys(clientMappedHSNData)?.length > 0) {
      
      setClientTurnOver(clientMappedHSNData?.client_turnover);
      setIsHSNCheck(
        clientMappedHSNData?.is_hsn_sac_code_check_active === 1
      );
      setEditId(clientMappedHSNData?.id);
    }else{
      setClientTurnOver("");
      setIsHSNCheck(
      false
      );
      setEditId("")
    }
  }, [clientMappedHSNData]);
  useEffect(() => {
    if (
      success === 1 &&
      message?.includes(
        "HSN SAC Code Check and Turnover details added successfully!"
      )
    ) {
      if (token) {
        let mappedFinalData = {
          token,
          clientCode: id,
        };
        dispatchGetHsnCheckAction(mappedFinalData);
      }
      toast.success(
        "HSN SAC Code Check and Turnover details added successfully!",
        {
          duration: 3000,
        }
      );
    }
    if (
      success === 1 &&
      message?.includes(
        "HSN SAC Code Check and Turnover details updated successfully!"
      )
    ) {
      if (token) {
        let mappedFinalData = {
          token,
          clientCode: id,
        };
        dispatchGetHsnCheckAction(mappedFinalData);
      }
      toast.success(
        "HSN SAC Code Check and Turnover details updated successfully!",
        {
          duration: 3000,
        }
      );
    }
  }, [success, message]);

  const handleSubmitHSN = () => {

    let finalData = {
      token,
      clientTurnover,
      clientCode: id,
      isHSNCheck: isHSNCheck ? 1 : 0,
    };

    dispatchAddTurnOverHSNCheckAction(finalData);
    dispatchResetClientSettingMessage();
    dispatchResetClientSettingsSuccess();
  };
  const handleUpdateHSN = () => {

    let finalData = {
      token,
      clientTurnover,
      clientCode: id,
      isHSNCheck: isHSNCheck ? 1 : 0,
    };

    dispatchUpdateTurnOverHSNCheckAction(finalData);
    dispatchResetClientSettingMessage();
    dispatchResetClientSettingsSuccess();
  };

  const handleChangeStatusHSN = () => {
    setIsHSNCheck(!isHSNCheck);
  };
  const handleClientTurnoverChange = (e: any) => {
    setClientTurnOver(e.target.value);
  };

  const handleGoBack = () => {
      history?.push({
        pathname: `/client-settings/${id}`,
        state: { client_code, company_name },
      });
   
  };

  const handleErrorModal = () => {
    if (success === 0 || masterSuccess === 0) {
      dispatchResetMasterSuccess();
      if (statusCode === 401 || masterStatusCode === 401) {
        return (
          <ErrorSuccessModal
            type="error"
            isOpen={!!error || !!masterError}
            title="Error"
            message="Session Expired. Please Login Again!"
            buttonText="Logout"
            onPress={() => dispatchResetSession()}
            statusCode={statusCode || masterStatusCode}
          />
        );
      } else if (
        (!!error || !!masterError) &&
        (statusCode !== 401 || masterStatusCode !== 401)
      ) {
        return (
          <ErrorSuccessModal
            type="error"
            isOpen={!!error || !!masterError}
            title="Error"
            message={error || masterError}
            buttonText="OK"
            onPress={() => {
              dispatchResetMasterError();
              dispatchResetMasterSuccess();
              dispatchResetMasterError();
              dispatchResetMasterMessage();
              dispatchResetMasterStatusCode();
              dispatchResetClientSettingsSuccess();
              dispatchResetClientSettingsError();
            }}
          />
        );
      }
    }
    
    return false;
  };
  return (
    <>
      <div className="d-flex align-items-center justify-content-between mb-2">
        <div style={{ maxWidth: "78%" }}>
          <p className="pdf_template_header">{menuName}</p>
          <p className="sub_heading">
            Please enable HSN settings if you want to use HSN validations
          </p>
        </div>
      </div>
      <div className="hsn-check-main-container mb-4">
        <label htmlFor="Stage" className="royaltyLabel ms-3">
          Is HSN Check Required ?
        </label>
        <div className="questions-toggle ms-3">
          <div className="toggleFilterMainDiv">
            <div className="toggleFilterInnerDiv">
              <ToggleSwitch
                handleToggleChange={() => handleChangeStatusHSN()}
                isChecked={isHSNCheck}
                name="dailyVoucherFilter"
              />

              <span className="mt-1 toogleTextLabel hsn-check-toggle-title">{isHSNCheck?"Yes":"No"}</span>
            </div>
          </div>
        </div>
      </div>
      <label htmlFor="client" className="">
        Client Turnover <span className="color-red">*</span>
      </label>

      <div className="col-md-3 pl-0 mb-5">
        <input
          className="form-control"
          type="number"
          value={clientTurnover}
          onChange={handleClientTurnoverChange}
        />
      </div>
      <hr></hr>
      <div className="row">
        <div className="col-md-12 text-right">
        <button
            className="btn "
            style={{ border: "1px solid #bfcbe1", marginRight: '15px' }}
            onClick={() => handleGoBack()}
          >
            {"Cancel"}
          </button>
          <button
            className="btn btn-primary"
            disabled={!clientTurnover}
            onClick={editId ? handleUpdateHSN : handleSubmitHSN}
          >
            {editId ? "Update" : "Save"}
          </button>
        </div>
      </div>
      <div className="pdfImages mt-3">
        <Toaster />
        {fetching && <Loader />}
      </div>
      {handleErrorModal()}
    </>
  );
};

const mapStateToProps = (state: RootState) => ({
  token: state.auth.token,
  masterFetching: state.masterData.fetching,
  masterStatusCode: state.masterData.statusCode,
  masterError: state.masterData.error,
  masterSuccess: state.masterData.success,
  masterMessage: state.masterData.message,
  success: state.clientSettings.success,
  fetching: state.clientSettings.fetching,
  error: state.clientSettings.error,
  statusCode: state.clientSettings.statusCode,
  message: state.clientSettings.message,

  clientMappedHSNData: state.clientSettings.clientMappedHSNData,
});

const mapDispatchToProps = (dispatch: any) => ({
  dispatchResetSession: () => dispatch(resetSession()),
  dispatchResetMasterSuccess: () => dispatch(resetMasterSuccess()),
  dispatchResetMasterError: () => dispatch(resetMasterError()),
  dispatchResetMasterMessage: () => dispatch(resetMasterMessage()),
  dispatchResetClientSettingMessage: () => dispatch(resetMessage()),
  dispatchResetMasterStatusCode: () => dispatch(resetMasterStatusCode()),
  dispatchResetClientSettingsSuccess: () =>
    dispatch(resetClientSettingsSuccess()),
  dispatchResetClientSettingsError: () => dispatch(resetClientSettingsError()),

  dispatchGetHsnCheckAction: (data: GetHSNCheckPayloadType) => dispatch(getHsnCheckAction(data)),
  dispatchAddTurnOverHSNCheckAction: (data: AddTurnOverHSNCheckPayloadType) =>
    dispatch(addTurnOverHSNCheckAction(data)),

  dispatchUpdateTurnOverHSNCheckAction: (data: UpdateTurnOverHSNCheckPayloadType) =>
    dispatch(updateTurnOverHSNCheckAction(data)),
  dispatchResetClientMappedHSNData: () => dispatch(resetClientMappedHSNData()),
});

export default connect(mapStateToProps, mapDispatchToProps)(HsnCheck);
